export async function createAssistantTitle({ message }, { signal, baseUrl } = {}) {
    const root = typeof baseUrl === "string" ? baseUrl.replace(/\/+$/, "") : "";
    const response = await fetch(`${root}/api/assistant/title`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ message }),
        signal
    });
    const parsed = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(`assistant_title_http_${response.status}`);
    return {
        title: String(parsed.title || ""),
        usedFallback: Boolean(parsed.usedFallback)
    };
}
